// src/oura/delivery/workFlag.ts
//
// Whether Delivery shows the Phase 3 work on its items (scope 3.1 to 3.9):
// the drafts a person started, the paste list, a proof file on Close by
// hand, the "Live since" reply, the AI reader test and approved copy to the
// site. Both switches must be on, and each fails closed on its own: Delivery
// (DELIVERY_ON) and the Docs writes (DOCS_WRITE_ON). A build missing either
// shows none of it.

import { DELIVERY_ON } from "./flag";
import { DOCS_WRITE_ON } from "../docs/writeFlag";

export const DELIVERY_WORK_ON = DELIVERY_ON && DOCS_WRITE_ON;
